import { useState } from "react";
import { Building } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ContactFormSection() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [message, setMessage] = useState("");
  return <section id="ContactForm" style={{
    backgroundColor: "rgb(255, 255, 255)",
    color: "rgb(26, 26, 26)",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');
        .contact-input {
          width: 100%;
          background: #FFFFFF;
          border: 1px solid #EAE9E4;
          border-radius: 0px;
          padding: 10px 12px;
          font-family: Inter, system-ui, -apple-system, sans-serif;
          font-size: 14px;
          color: #1A1A1A;
          line-height: 20px;
          outline: none;
          box-sizing: border-box;
        }
        .contact-input:focus {
          border-color: #E51F26;
        }
        .contact-input::placeholder {
          color: #9CA3AF;
        }
        .contact-select {
          width: 100%;
          background: #FFFFFF;
          border: 1px solid #EAE9E4;
          border-radius: 0px;
          padding: 10px 12px;
          font-family: Inter, system-ui, -apple-system, sans-serif;
          font-size: 14px;
          color: #6B7280;
          line-height: 20px;
          outline: none;
          appearance: none;
          -webkit-appearance: none;
          cursor: pointer;
          box-sizing: border-box;
        }
        .contact-select:focus {
          border-color: #E51F26;
        }
        .contact-textarea {
          width: 100%;
          background: #FFFFFF;
          border: 1px solid #EAE9E4;
          border-radius: 0px;
          padding: 10px 12px;
          font-family: Inter, system-ui, -apple-system, sans-serif;
          font-size: 14px;
          color: #1A1A1A;
          line-height: 20px;
          outline: none;
          resize: vertical;
          min-height: 80px;
          box-sizing: border-box;
        }
        .contact-textarea:focus {
          border-color: #E51F26;
        }
        .contact-textarea::placeholder {
          color: #9CA3AF;
        }
        .send-btn {
          width: 100%;
          background-color: #E51F26;
          color: #FFFFFF;
          font-family: Inter, system-ui, -apple-system, sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.6px;
          text-transform: uppercase;
          text-align: center;
          padding: 16px 24px;
          border: none;
          border-radius: 0px;
          cursor: pointer;
          box-shadow: rgba(0,0,0,0.1) 0px 4px 6px -1px, rgba(0,0,0,0.1) 0px 2px 4px -2px;
          transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .send-btn:hover {
          background-color: #c41920;
        }
        .contact-label {
          display: block;
          font-family: Inter, system-ui, -apple-system, sans-serif;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #1A1A1A;
          margin-bottom: 6px;
        }
      `}</style>

      <div style={{
      paddingTop: "clamp(96px, 8vw, 128px)",
      paddingBottom: "clamp(96px, 8vw, 128px)"
    }}>
        <div className="page-container">
          <div className="flex flex-col items-center text-center mb-10">
            <p style={{
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: "#E51F26",
            marginBottom: "12px"
          }}>
              GET IN TOUCH
            </p>

            <h2 style={{
            color: "rgb(26, 26, 26)",
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            fontSize: "48px",
            fontWeight: 500,
            lineHeight: "48px",
            letterSpacing: "-1.2px",
            textAlign: "center",
            marginBottom: "16px"
          }}>
              Let's start working together.
            </h2>

            <p style={{
            color: "oklch(0.551 0.027 264.364)",
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "16px",
            fontWeight: 300,
            lineHeight: "26px",
            textAlign: "center",
            maxWidth: "500px",
            marginBottom: "16px"
          }}>
              Whether you are seeking equipment for yourself or referring a patient, our team responds within one business day.
            </p>

            <div style={{
            width: "40px",
            height: "2px",
            backgroundColor: "#E51F26"
          }} />
          </div>

          <div className="flex flex-col items-center">
            <div style={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            borderRadius: "0px",
            boxShadow: "0 1px 8px 0 rgba(0,0,0,0.07)",
            padding: "32px",
            width: "100%",
            maxWidth: "460px",
            boxSizing: "border-box"
          }}>
              <div className="flex flex-col md:flex-row gap-4 mb-4">
                <div className="flex-1">
                  <label className="contact-label">FIRST NAME *</label>
                  <input className="contact-input" type="text" placeholder="Jane" value={firstName} onChange={e => setFirstName(e.target.value)} />
                </div>
                <div className="flex-1">
                  <label className="contact-label">LAST NAME *</label>
                  <input className="contact-input" type="text" placeholder="Smith" value={lastName} onChange={e => setLastName(e.target.value)} />
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4 mb-4">
                <div className="flex-1">
                  <label className="contact-label">EMAIL ADDRESS *</label>
                  <input className="contact-input" type="email" placeholder="jane.smith@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <div className="flex-1">
                  <label className="contact-label">PHONE NUMBER *</label>
                  <input className="contact-input" type="tel" placeholder="631-555-0199" value={phone} onChange={e => setPhone(e.target.value)} />
                </div>
              </div>

              <div className="mb-4">
                <label className="contact-label">I AM A... *</label>
                <div style={{
                position: "relative"
              }}>
                  <select className="contact-select" value={role} onChange={e => setRole(e.target.value)}>
                    <option value="" disabled>-- Please select your role --</option>
                    <option value="patient">Patient or Family</option>
                    <option value="provider">Healthcare Provider</option>
                  </select>
                  <span style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#6B7280",
                  display: "flex",
                  alignItems: "center"
                }}>
                    <span dangerouslySetInnerHTML={{
                    __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>`
                  }} />
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <label className="contact-label">MESSAGE (OPTIONAL)</label>
                <textarea className="contact-textarea" placeholder="How may our clinical team support your needs today?" value={message} onChange={e => setMessage(e.target.value)} />
              </div>

              <button className="send-btn" type="submit">
                SEND MESSAGE
              </button>
            </div>

            <div style={{
            marginTop: "40px",
            width: "100%",
            maxWidth: "460px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px"
          }}>
              <div className="flex items-center gap-[6px]">
                <span style={{
                color: "#E51F26",
                display: "flex",
                alignItems: "center"
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.17 3.42a2 2 0 0 1 1.9-2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z" />
                  </svg>
                </span>
                <span style={{
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "10px",
                fontWeight: 600,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "oklch(0.551 0.027 264.364)",
                marginRight: "4px"
              }}>
                  PHONE:
                </span>
                <Link to="tel:6317403058" style={{
                color: "rgb(26, 26, 26)",
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "20px",
                textDecoration: "none"
              }} className="hover:underline">
                  631-740-3058
                </Link>
              </div>

              <div className="flex items-center gap-[6px]">
                <span style={{
                color: "#E51F26",
                display: "flex",
                alignItems: "center"
              }}>
                  <span dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>`
                }} />
                </span>
                <span style={{
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "10px",
                fontWeight: 600,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "oklch(0.551 0.027 264.364)",
                marginRight: "4px"
              }}>
                  EMAIL:
                </span>
                <Link to="mailto:contact@remtechnologiesdme.com" style={{
                color: "rgb(26, 26, 26)",
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "20px",
                textDecoration: "none"
              }} className="hover:underline">
                  contact@remtechnologiesdme.com
                </Link>
              </div>

              <div className="flex items-center gap-[6px]">
                <span style={{
                color: "#E51F26",
                display: "flex",
                alignItems: "center"
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 17H2a3 3 0 0 0 3-3V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" />
                    <path d="M3 21h18" />
                    <path d="M8 21V9h14v12" />
                    <path d="M13 13h4" />
                    <path d="M13 17h4" />
                    <path d="M9 13h1" />
                    <path d="M9 17h1" />
                  </svg>
                </span>
                <span style={{
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "10px",
                fontWeight: 600,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "oklch(0.551 0.027 264.364)",
                marginRight: "4px"
              }}>
                  FAX:
                </span>
                <Link to="tel:5166461460" style={{
                color: "rgb(26, 26, 26)",
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "20px",
                textDecoration: "none"
              }} className="hover:underline">
                  (516) 646 - 1460
                </Link>
              </div>
            </div>

            <div style={{
            marginTop: "32px",
            width: "100%",
            maxWidth: "320px",
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "16px"
          }}>
              <div style={{
              backgroundColor: "#F5F4F0",
              borderRadius: "0px",
              padding: "24px"
            }}>
                <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "8px"
              }}>
                  <span style={{
                  color: "#E51F26",
                  display: "flex",
                  alignItems: "center"
                }}>
                    <span dangerouslySetInnerHTML={{
                    __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>`
                  }} />
                  </span>
                  <span style={{
                  fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  color: "#E51F26"
                }}>
                    EAST PATCHOGUE OFFICE
                  </span>
                </div>
                <p style={{
                color: "rgb(26, 26, 26)",
                fontFamily: '"Cormorant Garamond", Georgia, serif',
                fontSize: "18px",
                fontWeight: 500,
                lineHeight: "28px",
                textAlign: "left",
                marginBottom: "4px"
              }}>
                  Building 2 • Suite B
                </p>
                <p style={{
                color: "oklch(0.551 0.027 264.364)",
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                fontSize: "14px",
                fontWeight: 300,
                lineHeight: "22.75px",
                textAlign: "left",
                margin: 0
              }}>
                  285 Sills Rd, East Patchogue, NY BLDG 2 STE B
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}